import type { QueryClient } from "@tanstack/react-query";
import { folderKeys } from "~/components/side-bar/hooks/use-folder-mutations";
import type { Folder } from "~/types/api";
import { sidebarStorage } from "~/utils/sidebar-storage";

export const addTaskToFolder = (folders: Folder[], folderId: number, taskId: number) => {
  return folders.map((folder) =>
    folder.id === folderId
      ? { ...folder, folderTasks: [...(folder.folderTasks || []), { folderId, taskId }] }
      : folder
  );
};

export const replaceTaskIdInFolder = (
  folders: Folder[],
  folderId: number,
  oldTaskId: number,
  newTaskId: number
) => {
  return folders.map((folder) =>
    folder.id === folderId
      ? {
          ...folder,
          folderTasks: (folder.folderTasks || []).map((ft) =>
            ft.taskId === oldTaskId ? { ...ft, taskId: newTaskId } : ft
          ),
        }
      : folder
  );
};

export const updateFolderCache = (
  queryClient: QueryClient,
  brandId: number,
  updater: (folders: Folder[]) => Folder[]
) => {
  const queryKey = folderKeys.byBrand(brandId);
  const folders = queryClient.getQueryData<Folder[]>(queryKey);

  if (folders) {
    const updated = updater(folders);
    queryClient.setQueryData(queryKey, updated);
    sidebarStorage.cacheFolders(
      brandId,
      updated as Parameters<typeof sidebarStorage.cacheFolders>[1]
    );
  }
};
